module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"alertText":"The requested page was not found – it could be either deleted or moved elsewhere.","buttonText":"Proceed to home page"},"fi":{"alertText":"Valitettavasti hakemaasi sivua ei löytynyt – se on mahdollisesti joko siirretty tai poistettu.","buttonText":"Siirry etusivulle"}}')
  delete Component.options._Ctor
}
